import { ArrowDownIcon, ArrowUpIcon, ChevronsUpDownIcon } from 'lucide-react'

import { cn } from '@/utils'
import type { Sort } from './types'

interface SortIconProps {
  sort: Sort
  sortKey: string
}

export const SortIcon = ({ sort, sortKey }: SortIconProps) => {
  const isSorted = sort.key === sortKey

  let Icon = ChevronsUpDownIcon
  if (isSorted && sort.direction === 'asc') Icon = ArrowUpIcon
  if (isSorted && sort.direction === 'desc') Icon = ArrowDownIcon

  return (
    <Icon
      className={cn(
        'h-3.5 w-3.5 ml-1.5 shrink-0 text-muted-foreground',
        !isSorted && 'opacity-50',
      )}
    />
  )
}
